import { LoggerCore } from '@nab/nab-x-sdk-core';
import { getCookie } from '../utils';
import { configureDefaultSDKLogger, loggerWrapperAttribute } from './Logger.utils';
let instance;
export function getParentLoggerDetails(el) {
    const found = [];
    let parent = el.parentNode.host;
    let appDetails = el.attributes.getNamedItem(loggerWrapperAttribute);
    while (parent && parent.tagName !== 'BODY') {
        if (appDetails && appDetails.value) {
            found.push(appDetails.value);
        }
        parent = parent.parentNode.host;
        appDetails = parent.attributes.getNamedItem(loggerWrapperAttribute);
    }
    return found.length > 0 ? found : null;
}
/**
 * [[include:packages/consumer/sdk-browser/src/Logger/README.md]]
 */
class Logger extends LoggerCore {
    constructor(settings) {
        const { wrapper, consoleLevel, ...otherSettings } = settings;
        const parentAppStack = wrapper ? getParentLoggerDetails(wrapper) : undefined;
        // istanbul/typescript are not playing nice with super calls
        // see nab-x-sdk issue #56 for further explanation why we're ignoring this line from coverage.
        /* istanbul ignore next */
        super({ ...otherSettings, parentAppStack });
        if (!instance) {
            instance = this;
        }
        instance.consoleLevel = consoleLevel;
        return instance;
    }
    postLogs(logCategory) {
        const isConsoleDisabled = getCookie('consoleDisabled') === 'true';
        const logLevelInCookie = getCookie('logLevel');
        super.postLogs(logCategory, isConsoleDisabled, logLevelInCookie);
    }
    destroy() {
        super.destroy();
        // bring back the sdk logger config
        configureDefaultSDKLogger();
    }
}
// configure the Logger so we can collect logs right away
const sdkLoggerInterface = configureDefaultSDKLogger();
export { Logger, sdkLoggerInterface };
//# sourceMappingURL=Logger.js.map